import {
  getBreadCrumbList,
  getMenuByRouter,
  getHomeRoute,
  getNextRoute,
  routeHasExist,
  routeEqual,
  getRouteTitleHandled,
  localSave,
  localRead
} from '@/libs/util'
// import { saveErrorLogger } from '@/api/data'
import router from '@/router'
import routers from '@/router/routers'
import https from '@/js/http.js'
import config from '@/config'
const { homeName } = config

const closePage = (state, route) => {
  const nextRoute = getNextRoute(state.tagNavList, route)
  state.tagNavList = state.tagNavList.filter(item => {
    return !routeEqual(item, route)
  })
  router.push(nextRoute)
}

export default {
  state: {
    breadCrumbList: [],
    tagNavList: [],
    homeRoute: {},
    local: localRead('local'),
    errorList: [],
    hasReadErrorPage: false,
    faqChangeNum:0,
    givingNum:0,
    showPasswordFlag: false, // 全局展示输入密码框
    countryList: [],
    newMenuList: [],
  },
  getters: {
    menuList: (state, getters, rootState) => getMenuByRouter(routers, rootState.user.access),
    errorCount: state => state.errorList.length,
    showPasswordFlag: state => state.showPasswordFlag,
    getNewMenuList: (state) => state.newMenuList,
  },
  mutations: {
    faqChagee(state){
      state.faqChangeNum= state.faqChangeNum+1
    },
    changeGiving(state){
      state.givingNum= state.givingNum+1
    },
    setBreadCrumb (state, route) {
      state.breadCrumbList = getBreadCrumbList(route, state.homeRoute)
    },
    setHomeRoute (state, routes) {
      state.homeRoute = getHomeRoute(routes, homeName)
    },
    setTagNavList (state, list) {
      let tagList = []
      if (list) {
        tagList = [...list]
      } 
      if (tagList[0] && tagList[0].name !== homeName) tagList.shift()
      let homeTagIndex = tagList.findIndex(item => item.name == homeName)
      if (homeTagIndex > 0) {
        let homeTag = tagList.splice(homeTagIndex, 1)[0]
        tagList.unshift(homeTag)
      }
      state.tagNavList = tagList
    },
    closeTag (state, route) {
      let tag = state.tagNavList.filter(item => routeEqual(item, route))
      route = tag[0] ? tag[0] : null
      if (!route) return
      closePage(state, route)
    },
    addTag (state, { route, type = 'unshift' }) {
      let router = getRouteTitleHandled(route)
      if (!routeHasExist(state.tagNavList, router)) {
        if (type == 'push') state.tagNavList.push(router)
        else {
          if (router.name == homeName) state.tagNavList.unshift(router)
          else state.tagNavList.splice(1, 0, router)
        }
      }
    },

    addError (state, error) {
      state.errorList.push(error)
    },
    setHasReadErrorLoggerStatus (state, status = true) {
      state.hasReadErrorPage = status
    },
    setShowPasswordFlag(state, status) {
      state.showPasswordFlag = status;
    },
    setCountryList(state, countryList) {
      state.countryList = countryList;
    },
    setNewMenuList(state, newMenuList) {
      state.newMenuList = newMenuList;
    },    
  },
  actions: {
    addErrorLog ({ commit, rootState }, info) {
      if (!window.location.href.includes('error_logger_page')) commit('setHasReadErrorLoggerStatus', false)
      const { user: { token, userId, userName } } = rootState
      let data = {
        ...info,
        time: Date.parse(new Date()),
        token,
        userId,
        userName
      }
      // saveErrorLogger(info).then(() => {
      //   commit('addError', data)
      // })
    },
    async getCountryList({ commit, state }) {
      if (state.countryList.length > 1) {
        return state.countryList;
      }
      let reqCountryList = await https.getCountryList({}, {});
      reqCountryList = reqCountryList.data || {};
      const reqList = reqCountryList.data || [];
      reqList.unshift({
        name: 'All',
        value: 0,
      })
      commit('setCountryList', reqList);
      return reqList || [];
    },    
  }
}



// WEBPACK FOOTER //
// ./src/store/module/app.js